import { action } from 'typesafe-actions';
import { SyncClickActions } from '../../components/header/services/externalSystemService';

export enum ContextTypeKeys {
    TRANSFER_GRADES_LOADING = 'TRANSFER_GRADES_LOADING',
    SYNC_WITH_EXTERNAL_TEST = 'SYNC_WITH_EXTERNAL_TEST',
    SYNC_WITH_EXTERNAL_TEST_LOADING = 'SYNC_WITH_EXTERNAL_TEST_LOADING',
}

export const onSyncActionClick = (activeItem: string) => action(SyncClickActions.SYNC_ACTION_CLICKED, activeItem);

export const transferGradesLoading = (isLoading: boolean) => action(ContextTypeKeys.TRANSFER_GRADES_LOADING, {
    isLoading,
});

export const syncWithExternalTest = () => action(ContextTypeKeys.SYNC_WITH_EXTERNAL_TEST);


export const syncWithExternalTestLoading = (isLoading: boolean) => action(ContextTypeKeys.SYNC_WITH_EXTERNAL_TEST_LOADING, {
    isLoading,
});
